import batsCambodia from 'assets/photography/bats-cambodia.jpg';
import blueMountains from 'assets/photography/blue-mountains.jpg';
import dramaticUluru from 'assets/photography/dramatic-uluru.jpg';
import grampiansMotionBlur from 'assets/photography/grampians-motion-blur.jpg';
import katherineFarmlife from 'assets/photography/katherine-farmlife.jpg';
import lakeTekapo from 'assets/photography/lake-tekapo.jpg';
import marlboroughSoundsReflection from 'assets/photography/marlborough-sounds-reflection.jpg';
import marlboroughSounds from 'assets/photography/marlborough-sounds.jpg';
import kataTjutaSunset from 'assets/photography/kata-tjuta-sunset.jpg';
import melbourneCityScape from 'assets/photography/melbourne-cityscape.jpg';
import melbourneReflection from 'assets/photography/melbourne-reflection.jpg';
import milfordSounds from 'assets/photography/milford-sounds.jpg';
import mountCook from 'assets/photography/mount-cook.jpg';
import nuggetPoint from 'assets/photography/nugget-point.jpg';
import outbackAustralia from 'assets/photography/outback-australia.jpg';
import perfectSunset from 'assets/photography/perfect-sunset.jpg';
import purakaunuiFalls from 'assets/photography/purakaunui-falls.jpg';
import redrockReflections from 'assets/photography/redrock-reflections.jpg';
import ruralFarmlifeAustralia from 'assets/photography/rural-farmlife-australia.jpg';
import skiStAnton from 'assets/photography/ski-st-anton.jpg';
import stKildaHarbour from 'assets/photography/st-kilda-harbour.jpg';
import surfByronBay from 'assets/photography/surf-byron-bay.jpg';
import sydneyBridgeReflections from 'assets/photography/sydney-bridge-reflection.jpg';
import sydneyCityscape from 'assets/photography/sydney-cityscape.jpg';
import twelveApostles from 'assets/photography/twelve-apostles.jpg';
import waiotapuThermalPools from 'assets/photography/wai-o-tapu-thermal-pools.jpg';
import wyndhamLookout from 'assets/photography/wyndham-lookout.jpg';
import hoiAn from 'assets/photography/hoi-an-vietnam.jpg';
import mountainsNewZealand from 'assets/photography/mountains-new-zealand.jpg';
import astroPhotographyBroome from 'assets/photography/astro-photography-broome.jpg';
import astroPhotographyBushCamping from 'assets/photography/astro-photography-bush-camping.jpg';
import astroPhotographyKarijini from 'assets/photography/astro-photography-karijini.jpg';
import astroPhotographyRoadTrain from 'assets/photography/astro-photography-road-train.jpg';
import astroPhotographyTelescope from 'assets/photography/astro-photography-telescope.jpg';
import astroPhotographyTree from 'assets/photography/astro-photography-tree.jpg';
import astroPhotographyTwelveApostles from 'assets/photography/astro-photography-twelve-apostles.jpg';
import astroToursBroome from 'assets/photography/astro-tours-broome.jpg';
import milkywayGalacticCentre from 'assets/photography/milkyway-galactic-centre.jpg';

export const Photos = [
  {src: milkywayGalacticCentre, width:899, height:600},
  {src: waiotapuThermalPools, width:900, height:600},
  {src: sydneyBridgeReflections, width:1249, height:600},
  {src: redrockReflections, width:899, height:600},
  {src: sydneyCityscape, width:1871, height:600},
  {src: marlboroughSounds, width:1015, height:600},
  {src: batsCambodia, width:1069, height:600},
  {src: stKildaHarbour, width:899, height:600},
  {src: astroPhotographyKarijini, width:600, height:994},
  {src: ruralFarmlifeAustralia, width:896, height:600},
  {src: grampiansMotionBlur, width:1302, height:600},
  {src: mountCook, width:1256, height:600},
  {src: astroPhotographyRoadTrain, width:600, height:828},
  {src: twelveApostles, width:930, height:600},
  {src: skiStAnton, width:1341, height:600},
  {src: milfordSounds, width:970, height:600},
  {src: surfByronBay, width:900, height:600},
  {src: purakaunuiFalls, width:900, height:600},
  {src: astroPhotographyTree, width:600, height:899},
  {src: outbackAustralia, width:1339, height:600},
  {src: astroPhotographyTwelveApostles, width:600, height:845},
  {src: dramaticUluru, width:899, height:600},
  {src: astroPhotographyBushCamping, width:1088, height:600},
  {src: blueMountains, width:899, height:600},
  {src: melbourneCityScape, width:1382, height:600},
  {src: lakeTekapo, width:899, height:600},
  {src: katherineFarmlife, width:899, height:600},
  {src: perfectSunset, width:1056, height:600},
  {src: astroPhotographyTelescope, width:796, height:600},
  {src: marlboroughSoundsReflection, width:933, height:600},
  {src: nuggetPoint, width:900, height:600},
  {src: melbourneReflection, width:1085, height:600},
  {src: wyndhamLookout, width:973, height:600},
  {src: astroToursBroome, width:899, height:600},
  {src: kataTjutaSunset, width:2103, height:600},
  {src: astroPhotographyBroome, width:899, height:600}
];

export const TravelPhotos = [
  {src: sydneyBridgeReflections, width:1249, height:600},
  {src: sydneyCityscape, width:1871, height:600},
  {src: mountainsNewZealand, width:900, height:600},
  {src: batsCambodia, width:1069, height:600},
  {src: waiotapuThermalPools, width:900, height:600},
  {src: stKildaHarbour, width:899, height:600},
  {src: twelveApostles, width:930, height:600},
  {src: skiStAnton, width:1341, height:600},
  {src: grampiansMotionBlur, width:1302, height:600},
  {src: marlboroughSounds, width:1015, height:600},
  {src: ruralFarmlifeAustralia, width:896, height:600},
  {src: mountCook, width:1256, height:600},
  {src: marlboroughSoundsReflection, width:933, height:600},
  {src: surfByronBay, width:900, height:600},
  {src: lakeTekapo, width:899, height:600},
  {src: melbourneCityScape, width:1382, height:600},
  {src: outbackAustralia, width:1339, height:600},
  {src: wyndhamLookout, width:973, height:600},
  {src: purakaunuiFalls, width:900, height:600},
  {src: nuggetPoint, width:900, height:600},
  {src: milfordSounds, width:970, height:600},
  {src: melbourneReflection, width:1085, height:600},
  {src: dramaticUluru, width:899, height:600},
  {src: kataTjutaSunset, width:2103, height:600},
  {src: redrockReflections, width:899, height:600},
  {src: hoiAn, width:1150, height:600},
  {src: blueMountains, width:899, height:600},
  {src: katherineFarmlife, width:899, height:600},
  {src: perfectSunset, width:1056, height:600}
];

export const AstroPhotos = [
  {src: milkywayGalacticCentre, width:899, height:600},
  {src: astroPhotographyRoadTrain, width:600, height:828},
  {src: astroPhotographyTelescope, width:796, height:600},
  {src: astroPhotographyKarijini, width:600, height:994},
  {src: astroPhotographyBroome, width:899, height:600},
  {src: astroPhotographyTwelveApostles, width:600, height:845},
  {src: astroToursBroome, width:899, height:600},
  {src: astroPhotographyTree, width:600, height:899},
  {src: astroPhotographyBushCamping, width:1088, height:600}
];



// WEBPACK FOOTER //
// ./src/components/photography/Photos.js